import { Navigate } from "react-router-dom";

import { FeatureFlagToggle } from "@/domain/_shared/feature-flag/components/feature-flag-toggle";
import { lazyRoute } from "@/routes/lazy-route";

const ProjectUploadPage = lazyRoute(() => import("./projects/project-upload-page"), "ProjectUploadPage");

const MyProjectListLayout = lazyRoute(() => import("./my-projects/my-projects.layout"), "MyProjectListLayout");
const MyProjectsPage = lazyRoute(() => import("./my-projects/my-projects.page"), "MyProjectsPage");
const ProjectLayout = lazyRoute(() => import("./projects/$projectId/project.layout"), "ProjectLayout");
const ProjectPage = lazyRoute(() => import("./projects/$projectId/project.page"), "ProjectPage");
const ProjectActivityTabPage = lazyRoute(() => import("./projects/$projectId/project-activity-tab.page"), "ProjectActivityTabPage");
const ProjectDetailTabPage = lazyRoute(() => import("./projects/$projectId/project-detail-tab.page"), "ProjectDetailTabPage");
const ProjectDocumentsTabPage = lazyRoute(() => import("./projects/$projectId/project-documents-tab.page"), "ProjectDocumentsTabPage");
const ProjectFoerderscoutTabPage = lazyRoute(() => import("./projects/$projectId/project-foerderscout-tab.page"), "ProjectFoerderscoutTabPage");
const ProjectIndicatorListTabPage = lazyRoute(() => import("./projects/$projectId/project-indicator-list-tab.page"), "ProjectIndicatorListTabPage");
const ProjectMilestonesTabPage = lazyRoute(() => import("./projects/$projectId/project-milestones-tab.page"), "ProjectMilestonesTabPage");
const ProjectTaskListTabPage = lazyRoute(() => import("./projects/$projectId/project-task-list-tab.page"), "ProjectTaskListTabPage");
const ProjectListBoardPage = lazyRoute(() => import("./projects/(list)/project-list-board.page"), "ProjectListBoardPage");
const ProjectListDashboardPage = lazyRoute(() => import("./projects/(list)/project-list.dashboard.page"), "ProjectListDashboardPage");
const ProjectListLayout = lazyRoute(() => import("./projects/(list)/project-list.layout"), "ProjectListLayout");
const ProjectListPage = lazyRoute(() => import("./projects/(list)/project-list.page"), "ProjectListPage");
const ProjectListTimelinePage = lazyRoute(() => import("./projects/(list)/project-list-timeline.page"), "ProjectListTimelinePage");

const ProjectTrashPage = lazyRoute(() => import("@/domain/trash/routes/project-trash.page"), "ProjectTrashPage");

export const myProjectRoutes = [
  {
    path: "my-projects",
    element: <MyProjectListLayout />,
    children: [{ path: "", element: <MyProjectsPage /> }],
  },
];

export const projectRoutes = [
  {
    path: "projects",
    children: [
      {
        path: "",
        element: <ProjectListLayout />,
        children: [
          { path: "", element: <Navigate to="all" replace /> },
          { path: "all", element: <ProjectListPage /> },
          { path: "trash", element: <ProjectTrashPage /> },
          { path: "dashboard", element: <ProjectListDashboardPage /> },
          {
            path: "board",
            element: (
              <FeatureFlagToggle flag="enable-board-tab" fallback={<Navigate to=".." replace />}>
                <ProjectListBoardPage />
              </FeatureFlagToggle>
            ),
          },
          {
            path: "timeline",
            element: (
              <FeatureFlagToggle flag="enable-timeline-tab">
                <ProjectListTimelinePage />
              </FeatureFlagToggle>
            ),
          },
          { path: "upload", element: <ProjectUploadPage /> },
        ],
      },
      {
        path: ":projectId",
        element: <ProjectLayout />,
        children: [
          {
            path: "",
            element: <ProjectPage />,
            children: [
              { path: "", element: <Navigate to="details" replace /> },
              { path: "details", element: <ProjectDetailTabPage /> },
              { path: "foerderscout", element: <ProjectFoerderscoutTabPage /> },
              { path: "tasks", element: <ProjectTaskListTabPage /> },
              {
                path: "milestones",
                element: (
                  <FeatureFlagToggle flag="enable-milestone-tab">
                    <ProjectMilestonesTabPage />
                  </FeatureFlagToggle>
                ),
              },
              { path: "indicators", element: <ProjectIndicatorListTabPage /> },
              { path: "activity", element: <ProjectActivityTabPage /> },
              { path: "documents", element: <ProjectDocumentsTabPage /> },
            ],
          },
        ],
      },
    ],
  },
];
